import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authService from "../../api-authorization/AuthorizeService";

export const fetchAllTimetableLinks = createAsyncThunk(
    '/api/LinkTimetable/links',
    async (departmentId, { rejectWithValue }) => {
        const token = await authService.getAccessToken();
        var urlParams = departmentId !== null ? `api/LinkTimetable/links/${departmentId}` : `api/LinkTimetable/links`;
        const response = await fetch(window.Config.apiUrl + urlParams, {
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': !token ? {} : `Bearer ${token}`
            }),
            method: 'GET',
            redirect: 'follow'
        });

        if (!response.ok) {
            return rejectWithValue("Er is iets fout gegaan...");
        } else {
            return response.json();
        };
    }
);

export const fetchTimetablesToLink = createAsyncThunk(
    '/api/LinkTimetable/timetables',
    async (args, { rejectWithValue }) => {
        const token = await authService.getAccessToken();
        const response = await fetch(window.Config.apiUrl + `api/LinkTimetable/timetables`, {
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': !token ? {} : `Bearer ${token}`
            }),
            method: 'GET',
            redirect: 'follow'
        });

        if (!response.ok) {
            return rejectWithValue("Er is iets fout gegaan...");
        } else {
            return response.json();
        };
    }
);

export const fetchItemsToLink = createAsyncThunk(
    '/api/LinkTimetable/items/mode',
    async (mode, { rejectWithValue }) => {
        const token = await authService.getAccessToken();
        const response = await fetch(window.Config.apiUrl + `api/LinkTimetable/items/${mode}`, {
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': !token ? {} : `Bearer ${token}`
            }),
            method: 'GET',
            redirect: 'follow'
        });

        if (!response.ok) {
            return rejectWithValue("Er is iets fout gegaan...");
        } else {
            return response.json();
        };
    }
);

export const postTimetableLinks = createAsyncThunk(
    "/api/LinkTimetable/post",
    async (newTimetableLinks, { rejectWithValue }) => {
        const token = await authService.getAccessToken();
        const response = await fetch(
            window.Config.apiUrl + "api/LinkTimetable",
            {
                headers: new Headers({
                    "Content-Type": "application/json",
                    Authorization: !token ? {} : `Bearer ${token}`,
                }),
                method: "POST",
                redirect: "follow",
                body: JSON.stringify(newTimetableLinks),
            }
        );

        if (!response.ok) {
            return rejectWithValue("Er is iets fout gegaan...");
        } else {
            return response.json();
        };
    }
);

export const putTimetableLink = createAsyncThunk(
    "/api/LinkTimetable/put",
    async (timetableLink, { rejectWithValue }) => {
        const token = await authService.getAccessToken();
        const response = await fetch(
            window.Config.apiUrl + "api/LinkTimetable",
            {
                headers: new Headers({
                    "Content-Type": "application/json",
                    Authorization: !token ? {} : `Bearer ${token}`,
                }),
                method: "PUT",
                redirect: "follow",
                body: JSON.stringify(timetableLink),
            }
        );

        if (!response.ok) {
            return rejectWithValue("Er is iets fout gegaan...");
        } else {
            return response.json();
        };
    }
);

export const linkTimetableSlice = createSlice({
    name: 'linkTimetable',
    initialState: {
        timetableLinks: null,
        timetableLinksStatus: null,
        timetablesToLink: null,
        timetablesToLinkStatus: null,
        itemsToLink: null,
        itemsToLinkStatus: null,
        postTimetableLinkStatus: null,
        putTimetableLinkStatus: null,
        showTimetableLinkFailed: false
    },
    reducers: {
        setFailedTimetableLink: (state, action) => {
            state.showTimetableLinkFailed = action.payload;
        },
        resetTimetableLinkStatus: (state) => {
            state.putTimetableLinkStatus = null;
            state.postTimetableLinkStatus = null;
        },
        resetItemsToLink: (state) => {
            state.itemsToLink = null;
            state.itemsToLinkStatus = null;
        },
    },
    extraReducers: (builder) => {
        builder // GET TIMETABLES LINKS
            .addCase(fetchAllTimetableLinks.pending, (state) => {
                state.timetableLinksStatus = 'loading';
            })
            .addCase(fetchAllTimetableLinks.fulfilled, (state, action) => {
                state.timetableLinksStatus = 'success';
                state.timetableLinks = action.payload;
            })
            .addCase(fetchAllTimetableLinks.rejected, (state) => {
                state.timetableLinksStatus = 'failed';
            });

        builder // GET TIMETABLES
            .addCase(fetchTimetablesToLink.pending, (state) => {
                state.timetablesToLinkStatus = 'loading';
            })
            .addCase(fetchTimetablesToLink.fulfilled, (state, action) => {
                state.timetablesToLinkStatus = 'success';
                state.timetablesToLink = action.payload;
            })
            .addCase(fetchTimetablesToLink.rejected, (state) => {
                state.timetablesToLinkStatus = 'failed';
            });

        builder // GET ITEMS TO LINK
            .addCase(fetchItemsToLink.pending, (state) => {
                state.itemsToLinkStatus = 'loading';
            })
            .addCase(fetchItemsToLink.fulfilled, (state, action) => {
                state.itemsToLinkStatus = 'success';
                state.itemsToLink = action.payload;
            })
            .addCase(fetchItemsToLink.rejected, (state) => {
                state.itemsToLinkStatus = 'failed';
            });


        builder // POST
            .addCase(postTimetableLinks.pending, (state) => {
                state.postTimetableLinkStatus = 'loading';
            })
            .addCase(postTimetableLinks.fulfilled, (state) => {
                state.postTimetableLinkStatus = 'success';
            })
            .addCase(postTimetableLinks.rejected, (state) => {
                state.postTimetableLinkStatus = 'success';
            });

        builder // PUT
            .addCase(putTimetableLink.pending, (state) => {
                state.putTimetableLinkStatus = 'loading';
            })
            .addCase(putTimetableLink.fulfilled, (state) => {
                state.putTimetableLinkStatus = 'success';
            })
            .addCase(putTimetableLink.rejected, (state) => {
                state.putTimetableLinkStatus = 'failed';
            });
    },
});

export const {
    setFailedTimetableLink,
    resetTimetableLinkStatus,
    resetItemsToLink
} = linkTimetableSlice.actions;

export default linkTimetableSlice.reducer;
